import { render, staticRenderFns } from "./TkLeftArrow.vue?vue&type=template&id=b0bcf898&"
import script from "./TkLeftArrow.vue?vue&type=script&lang=js&"
export * from "./TkLeftArrow.vue?vue&type=script&lang=js&"
import style0 from "./TkLeftArrow.vue?vue&type=style&index=0&id=b0bcf898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports